module.exports = __webpack_public_path__ + "static/media/FT_L_P2.348b4a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/wounds/FT_L_P2.png
// module id = 2228
// module chunks = 0